import { Checkbox } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { ChangeEvent } from 'react';
import { useCallback } from 'react';
import { VisibilityState } from '../constants';
import type { SettingsStore } from '../store';

export const SelectAllGroupsCheckbox = observer(
	({ store }: { store: SettingsStore }) => {
		const toggleAllVisibility = useCallback(
			(event: ChangeEvent<HTMLInputElement>) => {
				store.setAllVisible(event.target.checked);
			},
			[store]
		);

		return (
			<Checkbox
				checked={[
					VisibilityState.VISIBLE,
					VisibilityState.INDETERMINATE,
				].includes(store.areAllVisible())}
				indeterminate={store.areAllVisible() === VisibilityState.INDETERMINATE}
				onChange={toggleAllVisibility}
			/>
		);
	}
);
